import { ParsedUrlQuery } from "querystring";

export const getRedirFromQueryValue = (
	value: string | string[] | undefined,
): string | undefined => {
	if (Array.isArray(value)) return value[0];
	return value;
};

export const getRedirFromQuery = (
	query: ParsedUrlQuery,
): string | undefined => {
	return getRedirFromQueryValue(query.redir);
};

export const isSafeInternalRedirPath = (value: string): boolean => {
	if (!value.startsWith("/")) return false;
	if (value.startsWith("//")) return false;
	if (value.includes("://")) return false;
	const pathname = value.split(/[?#]/, 1)[0] ?? "";
	const [root] = pathname.split("/").filter(Boolean);
	return ![
		"api",
		"internal",
		"sign-in",
		"sign-in-v2",
		"forgot-password",
		"forgot-password-v2",
	].includes(root ?? "");
};

export const resolveSafeRedirOrFallback = ({
	redir,
	fallback,
	accountSlug,
}: {
	redir: string | undefined;
	fallback: string;
	accountSlug?: string;
}): string => {
	if (!redir) return fallback;

	let decoded = redir;
	try {
		decoded = decodeURIComponent(redir);
	} catch {
		return fallback;
	}

	const normalized = decoded.trim();
	if (!normalized) return fallback;

	if (!isSafeInternalRedirPath(normalized)) return fallback;
	if (accountSlug) {
		const [root] =
			normalized.split(/[?#]/, 1)[0]?.split("/").filter(Boolean) ?? [];
		if (root !== accountSlug) return fallback;
	}
	return normalized;
};

export const withRedirQuery = ({
	signInPath,
	redirPath,
}: {
	signInPath: string;
	redirPath: string;
}): string => {
	const encodedRedir = encodeURIComponent(redirPath);
	const separator = signInPath.includes("?") ? "&" : "?";
	return `${signInPath}${separator}redir=${encodedRedir}`;
};
